import { render } from "./notes-carousel.vue?vue&type=template&id=04368cdf"
import script from "./notes-carousel.vue?vue&type=script&lang=js"
export * from "./notes-carousel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__